// Placeholder client words, anonymised to initials as counselling practice usually requires.
// Replace the quotes with real, consented testimonials before going live.
export const TESTIMONIALS = [
  {
    id: "jbp-1",
    quote:
      "I came in wanting advice about my business and left understanding something about myself I had been avoiding for eleven years. Rajdeep named the pattern in the first twenty minutes. I have not been able to unsee it since.",
    author: "A. S.",
    role: "Business owner",
    city: "Jabalpur",
  },
  {
    id: "hyd-1",
    quote:
      "I have done therapy. This is not that. It is faster, plainer and slightly uncomfortable in the way that useful things are. Three sessions in, I stopped reacting to my team the way my father reacted to me.",
    author: "K. R.",
    role: "Engineering lead",
    city: "Hyderabad",
  },
  {
    id: "ggn-1",
    quote:
      "From the outside my life looked handled. Inside, something had been humming for years. Rajdeep didn't try to fix me. She showed me the loop, and then it simply had less power.",
    author: "M. K.",
    role: "Strategy consultant",
    city: "Gurgaon",
  },
  {
    id: "jbp-2",
    quote:
      "I had never said some of those things out loud to anyone. She didn't flinch, and she didn't rush me. I walked out lighter than I have felt in a very long time.",
    author: "P. T.",
    role: "Architect",
    city: "Jabalpur",
  },
  {
    id: "fbd-1",
    quote:
      "We kept having the same argument in different clothes. One conversation with Rajdeep and we could finally see whose pattern was speaking. It changed how we talk at home.",
    author: "S. & V.",
    role: "Married, eight years",
    city: "Faridabad",
  },
];
